(function ($) {
    $(document).ready(function () {
        const googlePlayStoreLink = $('#googlePlayStoreLink').val();
        const appleAppStoreLink = $('#appleAppStoreLink').val();
        const searchValue = $('#searchValue').val();
        const autoRedirectToggle = Boolean($('#autoRedirectToggle').val());
        const isExperienceEditor = Boolean($('#isExperienceEditor').val());

        if(autoRedirectToggle && !isExperienceEditor) {
            const userAgent = navigator.userAgent;
            const link = (/iPad|iPhone|iPod/.test(userAgent)) ? appleAppStoreLink :
                (/android/i.test(userAgent)) ? googlePlayStoreLink :
                    searchValue;
            window.open(link, "_self");
        }
    });
})(window.jQuery);
